var _defs, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebQr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-dot-color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,26,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,26,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,26,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,26,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,26,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,26,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,26,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,42,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 178,
    width: 16,
    height: 16,
    transform: "rotate(0,42,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,42,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,42,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,42,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,58,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 178,
    width: 16,
    height: 16,
    transform: "rotate(0,58,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,58,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,58,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,58,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,58,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,74,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,74,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,74,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,74,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,74,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,74,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,74,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,74,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,90,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,90,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,90,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,90,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,90,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 274,
    width: 16,
    height: 16,
    transform: "rotate(0,90,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,90,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,90,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,90,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,106,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,106,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,106,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 274,
    width: 16,
    height: 16,
    transform: "rotate(0,106,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,106,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,106,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,106,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,122,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 178,
    width: 16,
    height: 16,
    transform: "rotate(0,122,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,122,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,122,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 274,
    width: 16,
    height: 16,
    transform: "rotate(0,122,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,122,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,122,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,138,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,138,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,138,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,138,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,138,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 34,
    width: 16,
    height: 16,
    transform: "rotate(0,154,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 66,
    width: 16,
    height: 16,
    transform: "rotate(0,154,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 82,
    width: 16,
    height: 16,
    transform: "rotate(0,154,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 98,
    width: 16,
    height: 16,
    transform: "rotate(0,154,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 114,
    width: 16,
    height: 16,
    transform: "rotate(0,154,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,154,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,154,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,154,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,154,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,154,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,154,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,154,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 354,
    width: 16,
    height: 16,
    transform: "rotate(0,154,362)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 370,
    width: 16,
    height: 16,
    transform: "rotate(0,154,378)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,154,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 418,
    width: 16,
    height: 16,
    transform: "rotate(0,154,426)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 450,
    width: 16,
    height: 16,
    transform: "rotate(0,154,458)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 34,
    width: 16,
    height: 16,
    transform: "rotate(0,170,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 66,
    width: 16,
    height: 16,
    transform: "rotate(0,170,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 82,
    width: 16,
    height: 16,
    transform: "rotate(0,170,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 98,
    width: 16,
    height: 16,
    transform: "rotate(0,170,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,170,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,170,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,170,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,170,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 386,
    width: 16,
    height: 16,
    transform: "rotate(0,170,394)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,170,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 434,
    width: 16,
    height: 16,
    transform: "rotate(0,170,442)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 450,
    width: 16,
    height: 16,
    transform: "rotate(0,170,458)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 18,
    width: 16,
    height: 16,
    transform: "rotate(0,186,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 34,
    width: 16,
    height: 16,
    transform: "rotate(0,186,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 98,
    width: 16,
    height: 16,
    transform: "rotate(0,186,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 114,
    width: 16,
    height: 16,
    transform: "rotate(0,186,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 130,
    width: 16,
    height: 16,
    transform: "rotate(0,186,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,186,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,186,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,186,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 354,
    width: 16,
    height: 16,
    transform: "rotate(0,186,362)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 370,
    width: 16,
    height: 16,
    transform: "rotate(0,186,378)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 418,
    width: 16,
    height: 16,
    transform: "rotate(0,186,426)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 434,
    width: 16,
    height: 16,
    transform: "rotate(0,186,442)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 34,
    width: 16,
    height: 16,
    transform: "rotate(0,202,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 50,
    width: 16,
    height: 16,
    transform: "rotate(0,202,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 66,
    width: 16,
    height: 16,
    transform: "rotate(0,202,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 130,
    width: 16,
    height: 16,
    transform: "rotate(0,202,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,202,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,202,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,202,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,202,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 274,
    width: 16,
    height: 16,
    transform: "rotate(0,202,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,202,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,202,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,202,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 418,
    width: 16,
    height: 16,
    transform: "rotate(0,202,426)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 466,
    width: 16,
    height: 16,
    transform: "rotate(0,202,474)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 34,
    width: 16,
    height: 16,
    transform: "rotate(0,218,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 50,
    width: 16,
    height: 16,
    transform: "rotate(0,218,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 98,
    width: 16,
    height: 16,
    transform: "rotate(0,218,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 114,
    width: 16,
    height: 16,
    transform: "rotate(0,218,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,218,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 178,
    width: 16,
    height: 16,
    transform: "rotate(0,218,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,218,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,218,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,218,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 354,
    width: 16,
    height: 16,
    transform: "rotate(0,218,362)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 370,
    width: 16,
    height: 16,
    transform: "rotate(0,218,378)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 450,
    width: 16,
    height: 16,
    transform: "rotate(0,218,458)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 50,
    width: 16,
    height: 16,
    transform: "rotate(0,234,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 66,
    width: 16,
    height: 16,
    transform: "rotate(0,234,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 82,
    width: 16,
    height: 16,
    transform: "rotate(0,234,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 98,
    width: 16,
    height: 16,
    transform: "rotate(0,234,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,234,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,234,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 178,
    width: 16,
    height: 16,
    transform: "rotate(0,234,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,234,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,234,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,234,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,234,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,234,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 370,
    width: 16,
    height: 16,
    transform: "rotate(0,234,378)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,234,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 434,
    width: 16,
    height: 16,
    transform: "rotate(0,234,442)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 466,
    width: 16,
    height: 16,
    transform: "rotate(0,234,474)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 18,
    width: 16,
    height: 16,
    transform: "rotate(0,250,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 98,
    width: 16,
    height: 16,
    transform: "rotate(0,250,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 114,
    width: 16,
    height: 16,
    transform: "rotate(0,250,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 130,
    width: 16,
    height: 16,
    transform: "rotate(0,250,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,250,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 178,
    width: 16,
    height: 16,
    transform: "rotate(0,250,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,250,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,250,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,250,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 370,
    width: 16,
    height: 16,
    transform: "rotate(0,250,378)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 386,
    width: 16,
    height: 16,
    transform: "rotate(0,250,394)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 418,
    width: 16,
    height: 16,
    transform: "rotate(0,250,426)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 466,
    width: 16,
    height: 16,
    transform: "rotate(0,250,474)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 66,
    width: 16,
    height: 16,
    transform: "rotate(0,266,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 82,
    width: 16,
    height: 16,
    transform: "rotate(0,266,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 98,
    width: 16,
    height: 16,
    transform: "rotate(0,266,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 130,
    width: 16,
    height: 16,
    transform: "rotate(0,266,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,266,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,266,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,266,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,266,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 274,
    width: 16,
    height: 16,
    transform: "rotate(0,266,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,266,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,266,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,266,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,266,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 354,
    width: 16,
    height: 16,
    transform: "rotate(0,266,362)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 370,
    width: 16,
    height: 16,
    transform: "rotate(0,266,378)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,266,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 418,
    width: 16,
    height: 16,
    transform: "rotate(0,266,426)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 434,
    width: 16,
    height: 16,
    transform: "rotate(0,266,442)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 450,
    width: 16,
    height: 16,
    transform: "rotate(0,266,458)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 466,
    width: 16,
    height: 16,
    transform: "rotate(0,266,474)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 50,
    width: 16,
    height: 16,
    transform: "rotate(0,282,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 82,
    width: 16,
    height: 16,
    transform: "rotate(0,282,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 114,
    width: 16,
    height: 16,
    transform: "rotate(0,282,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 130,
    width: 16,
    height: 16,
    transform: "rotate(0,282,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,282,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,282,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,282,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,282,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,282,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 274,
    width: 16,
    height: 16,
    transform: "rotate(0,282,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,282,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,282,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 418,
    width: 16,
    height: 16,
    transform: "rotate(0,282,426)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 466,
    width: 16,
    height: 16,
    transform: "rotate(0,282,474)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 18,
    width: 16,
    height: 16,
    transform: "rotate(0,298,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 34,
    width: 16,
    height: 16,
    transform: "rotate(0,298,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 50,
    width: 16,
    height: 16,
    transform: "rotate(0,298,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 66,
    width: 16,
    height: 16,
    transform: "rotate(0,298,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 130,
    width: 16,
    height: 16,
    transform: "rotate(0,298,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 178,
    width: 16,
    height: 16,
    transform: "rotate(0,298,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,298,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 274,
    width: 16,
    height: 16,
    transform: "rotate(0,298,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,298,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,298,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,298,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 18,
    width: 16,
    height: 16,
    transform: "rotate(0,314,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 34,
    width: 16,
    height: 16,
    transform: "rotate(0,314,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 66,
    width: 16,
    height: 16,
    transform: "rotate(0,314,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 114,
    width: 16,
    height: 16,
    transform: "rotate(0,314,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,314,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,314,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,314,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,314,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,314,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,314,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,314,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 418,
    width: 16,
    height: 16,
    transform: "rotate(0,314,426)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 434,
    width: 16,
    height: 16,
    transform: "rotate(0,314,442)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 466,
    width: 16,
    height: 16,
    transform: "rotate(0,314,474)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 18,
    width: 16,
    height: 16,
    transform: "rotate(0,330,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 34,
    width: 16,
    height: 16,
    transform: "rotate(0,330,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 50,
    width: 16,
    height: 16,
    transform: "rotate(0,330,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 82,
    width: 16,
    height: 16,
    transform: "rotate(0,330,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,330,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,330,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,330,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,330,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 354,
    width: 16,
    height: 16,
    transform: "rotate(0,330,362)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 370,
    width: 16,
    height: 16,
    transform: "rotate(0,330,378)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 386,
    width: 16,
    height: 16,
    transform: "rotate(0,330,394)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 434,
    width: 16,
    height: 16,
    transform: "rotate(0,330,442)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 18,
    width: 16,
    height: 16,
    transform: "rotate(0,346,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 34,
    width: 16,
    height: 16,
    transform: "rotate(0,346,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 50,
    width: 16,
    height: 16,
    transform: "rotate(0,346,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 66,
    width: 16,
    height: 16,
    transform: "rotate(0,346,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 82,
    width: 16,
    height: 16,
    transform: "rotate(0,346,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 98,
    width: 16,
    height: 16,
    transform: "rotate(0,346,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 114,
    width: 16,
    height: 16,
    transform: "rotate(0,346,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,346,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,346,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,346,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 274,
    width: 16,
    height: 16,
    transform: "rotate(0,346,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,346,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,346,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 354,
    width: 16,
    height: 16,
    transform: "rotate(0,346,362)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 370,
    width: 16,
    height: 16,
    transform: "rotate(0,346,378)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 386,
    width: 16,
    height: 16,
    transform: "rotate(0,346,394)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,346,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 434,
    width: 16,
    height: 16,
    transform: "rotate(0,346,442)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 450,
    width: 16,
    height: 16,
    transform: "rotate(0,346,458)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,362,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,362,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,362,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,362,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,362,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,362,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,362,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 418,
    width: 16,
    height: 16,
    transform: "rotate(0,362,426)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 434,
    width: 16,
    height: 16,
    transform: "rotate(0,362,442)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,378,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 178,
    width: 16,
    height: 16,
    transform: "rotate(0,378,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,378,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,378,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,378,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,378,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 274,
    width: 16,
    height: 16,
    transform: "rotate(0,378,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,378,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,378,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,378,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,378,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 370,
    width: 16,
    height: 16,
    transform: "rotate(0,378,378)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,378,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 434,
    width: 16,
    height: 16,
    transform: "rotate(0,378,442)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,394,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,394,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,394,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,394,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,394,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,394,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,394,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,394,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,394,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 418,
    width: 16,
    height: 16,
    transform: "rotate(0,394,426)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 450,
    width: 16,
    height: 16,
    transform: "rotate(0,394,458)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,410,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,410,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 178,
    width: 16,
    height: 16,
    transform: "rotate(0,410,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,410,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,410,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,410,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 274,
    width: 16,
    height: 16,
    transform: "rotate(0,410,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,410,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,410,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,410,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,410,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 354,
    width: 16,
    height: 16,
    transform: "rotate(0,410,362)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 370,
    width: 16,
    height: 16,
    transform: "rotate(0,410,378)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 386,
    width: 16,
    height: 16,
    transform: "rotate(0,410,394)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,410,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 450,
    width: 16,
    height: 16,
    transform: "rotate(0,410,458)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 466,
    width: 16,
    height: 16,
    transform: "rotate(0,410,474)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,426,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,426,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,426,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,426,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 274,
    width: 16,
    height: 16,
    transform: "rotate(0,426,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,426,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 386,
    width: 16,
    height: 16,
    transform: "rotate(0,426,394)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 418,
    width: 16,
    height: 16,
    transform: "rotate(0,426,426)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 434,
    width: 16,
    height: 16,
    transform: "rotate(0,426,442)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 450,
    width: 16,
    height: 16,
    transform: "rotate(0,426,458)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,442,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,442,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,442,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,442,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,442,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 274,
    width: 16,
    height: 16,
    transform: "rotate(0,442,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,442,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,442,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 354,
    width: 16,
    height: 16,
    transform: "rotate(0,442,362)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 386,
    width: 16,
    height: 16,
    transform: "rotate(0,442,394)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,442,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 418,
    width: 16,
    height: 16,
    transform: "rotate(0,442,426)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 450,
    width: 16,
    height: 16,
    transform: "rotate(0,442,458)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 466,
    width: 16,
    height: 16,
    transform: "rotate(0,442,474)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,458,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 178,
    width: 16,
    height: 16,
    transform: "rotate(0,458,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,458,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,458,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,458,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,458,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,458,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,458,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 370,
    width: 16,
    height: 16,
    transform: "rotate(0,458,378)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,458,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 434,
    width: 16,
    height: 16,
    transform: "rotate(0,458,442)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 466,
    width: 16,
    height: 16,
    transform: "rotate(0,458,474)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 178,
    width: 16,
    height: 16,
    transform: "rotate(0,474,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,474,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,474,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,474,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,474,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,474,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 354,
    width: 16,
    height: 16,
    transform: "rotate(0,474,362)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 370,
    width: 16,
    height: 16,
    transform: "rotate(0,474,378)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 386,
    width: 16,
    height: 16,
    transform: "rotate(0,474,394)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,474,410)"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 18 18v 112h 112v -112zM 34 34h 80v 80h -80z",
    transform: "rotate(0,74,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 50,
    width: 48,
    height: 48,
    transform: "rotate(0,74,74)"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 370 18v 112h 112v -112zM 386 34h 80v 80h -80z",
    transform: "rotate(90,426,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 50,
    width: 48,
    height: 48,
    transform: "rotate(90,426,74)"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 18 370v 112h 112v -112zM 34 386h 80v 80h -80z",
    transform: "rotate(-90,74,426)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 402,
    width: 48,
    height: 48,
    transform: "rotate(-90,74,426)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    height: 500,
    width: 500,
    clipPath: "url('#clip-path-background-color')",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    height: 500,
    width: 500,
    clipPath: "url('#clip-path-dot-color')",
    fill: "#000000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebQr);
export default __webpack_public_path__ + "static/media/webQR.f77249b1885a9a0e56556d6c9eeeed8f.svg";
export { ForwardRef as ReactComponent };